package com.xtream.data_kmp.db.repo

import androidx.paging.Pager
import androidx.paging.PagingConfig
import androidx.paging.PagingData
import androidx.paging.PagingSource
import androidx.room3.RoomRawQuery
import com.xtream.data_kmp.AllConst
import com.xtream.data_kmp.AllConst.PAGING_PAGE_SIZE
import com.xtream.data_kmp.FavoriteLiveStreamEntity
import com.xtream.data_kmp.db.AppRoomDB
import com.xtream.data_kmp.db.dao.BaseRoomStreamsInterface
import com.xtream.data_kmp.db.dao.LiveSortBy
import com.xtream.data_kmp.db.dao.RoomBaseInterface
import com.xtream.data_kmp.db.tables.LiveCategoryWithVisibleStatus
import com.xtream.data_kmp.db.tables.LiveStreamOrderEntity
import com.xtream.data_kmp.db.tables.StreamType
import com.xtream.data_kmp.db.tables.toHiddenCategoryEntity
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.LiveStreamWithSortOrder
import kotlinx.coroutines.flow.Flow


class LiveStreamsRepository (
    val db: AppRoomDB
): LocalStreamsRepository<LiveStream, FavoriteLiveStreamEntity, LiveCategory>(
    db.liveStreamsDao() as BaseRoomStreamsInterface<LiveStream>,
    db.liveFavoritesDao() as RoomBaseInterface<FavoriteLiveStreamEntity>,
    db.liveCategoriesDao() as RoomBaseInterface<LiveCategory>
) {

suspend fun getCategory(categoryId:Int?): LiveCategory? {

    return if(categoryId==null )null else db.liveCategoriesDao().getCategory(categoryId) }

    suspend fun findNextItem(currentItemPosition:Int,addBy:Int,fromCategoryID:Int?,onDone:(item: LiveStream?, position:Int)->Unit) {
        //check if favorite get Fav Size otherwise get size from Tv Channels
        val count=(
                if(fromCategoryID== AllConst.FAV_CATEGORIES_ID.toInt())
                    db.liveFavoritesDao().getSize()
                else
                    db.liveStreamsDao().getSize(fromCategoryID)
                )?.toInt()
        if(count==null||count==0)return

        //
       val nexPosition=if(addBy==0)
           if (currentItemPosition in 1..count.minus(1)) currentItemPosition else count-1
               else
           (currentItemPosition + addBy + count) % count
        //check if favorite get Fav Size otherwise get size from Tv Channels

        val item=
            if(fromCategoryID==AllConst.FAV_CATEGORIES_ID.toInt())
                db.liveFavoritesDao().getByOffset(nexPosition)
            else db.liveStreamsDao().getByOffset(fromCategoryID,nexPosition)
        onDone(item,nexPosition)
    }


    suspend fun findItemByOffset(offset:Int,fromCategoryID:Int?): LiveStream? {
         return if(fromCategoryID==AllConst.FAV_CATEGORIES_ID.toInt())
            db.liveFavoritesDao().getByOffset(offset)
        else
            db.liveStreamsDao().getByOffset(fromCategoryID,offset)
    }


     fun getCategoriesWithTvChannels() =
         db.liveStreamsDao().categoriesWithStreams()
    //fun getCategoriesWithTvChannelsFlow() =
      //   db.liveStreamsDao().categoriesWithStreamsFlow()

   /*suspend fun indexOf(categoryId: Int?,streamId: Int):Int? {

      return  db.liveStreamsDao().indexOf(
          RoomRawQuery(
              """
        SELECT COUNT(*) AS item_index
        FROM $liveStreamsTable AS liveStreams2
        LEFT JOIN hidden_categories h
            ON liveStreams2.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
          AND liveStreams2.categoryId = ?
          AND liveStreams2.num < (
              SELECT num FROM $liveStreamsTable WHERE streamId = ? AND categoryId = ?
          )
        """,
              onBindStatement = {
                  it.bindInt(1, categoryId ?: -1)
                  it.bindInt(2, streamId)
                  it.bindInt(3, categoryId ?: -1)
              }
          )
      )
    }
 */

    suspend fun indexOf(
        streamId: Int,
        categoryId: Int?,
        followUserOrder: Boolean = true
    ): Int? {
        val joinClause = if (followUserOrder) {
            "LEFT JOIN live_stream_order o ON l.streamId = o.streamId"
        } else {
            ""
        }

        val categoryFilter = if (categoryId != null) {
            "AND l.categoryId = $categoryId"
        } else {
            ""
        }

        val sortExpr = if (followUserOrder) {
            "COALESCE(o.position, l.num)"
        } else {
            "l.num"
        }

        val targetJoin = if (followUserOrder) {
            "LEFT JOIN live_stream_order o2 ON l2.streamId = o2.streamId"
        } else {
            ""
        }

        val targetJoin2 = if (followUserOrder) {
            "LEFT JOIN live_stream_order o2 ON l2b.streamId = o2.streamId"
        } else {
            ""
        }

        val targetExpr = if (followUserOrder) {
            "COALESCE(o2.position, l2.num)"
        } else {
            "l2.num"
        }

        val targetExpr2 = if (followUserOrder) {
            "COALESCE(o2.position, l2b.num)"
        } else {
            "l2b.num"
        }

        val sql = """
        SELECT COUNT(*) FROM liveStreamsTable l
        $joinClause
        LEFT JOIN hidden_categories h
            ON l.categoryId = h.categoryId AND h.type = 'LIVE'
        WHERE h.categoryId IS NULL
        $categoryFilter
        AND (
            $sortExpr < (
                SELECT $targetExpr
                FROM liveStreamsTable l2
                $targetJoin
                WHERE l2.streamId = $streamId
            )
            OR (
                $sortExpr = (
                    SELECT $targetExpr2
                    FROM liveStreamsTable l2b
                    $targetJoin2
                    WHERE l2b.streamId = $streamId
                )
                AND l.streamId < $streamId
            )
        )
    """.trimIndent()

        return db.liveStreamsDao().indexOf(RoomRawQuery(sql))
    }
//    fun isFavoriteAsFlow(streamId: Int) = db.liveFavoritesDao().hasEntityAsFlow(streamId)

fun  getPagedCategoriesWithStreams()= db.liveCategoriesDao().getPagingCategoriesWithSize()
suspend fun all(categoryId:Int?=AllConst.ALL_CATEGORIES_ID.toInt(), nameQuery:String?="",limit: Int?=15, offset: Int?=0) = db.liveStreamsDao().all(categoryId=categoryId,nameQuery=nameQuery, limit=limit, offset=offset)
    suspend fun getWatchedStreams(limit: Int?=null) = db.liveStreamsDao().getWatchedStreams(limit)

    suspend fun getStreamById(streamId: Int?) = db.liveStreamsDao().getStreamById(streamId)






    // Only in LiveStreamsRepository, not the base class
    fun getStreamsAsPagingSource(
        categoryIds: List<Int>?,
        nameQuery: String?,
        sortBy: LiveSortBy,
    ): PagingSource<Int, LiveStream> = db.liveStreamsDao().allAsPagingSource(categoryIds, nameQuery, sortBy)


    fun getPagedLiveStreamsFlow(
        categoryIds: List<Int>? = null,
        searchQuery: String? = null,
        sortBy: LiveSortBy
    ): Flow<PagingData<LiveStream>> = Pager<Int, LiveStream>(
        config = PagingConfig(
            pageSize = PAGING_PAGE_SIZE,
            enablePlaceholders = false,
        ),
        pagingSourceFactory = {
            when  {
                categoryIds.isNullOrEmpty() -> getStreamsAsPagingSource(null, searchQuery, sortBy)
                categoryIds.firstOrNull() ==AllConst.FAV_CATEGORIES_ID.toInt() -> getFavoritesPagingSource()
                else ->   getStreamsAsPagingSource(categoryIds, searchQuery, sortBy)

            }
        }
    ).flow


    fun getOrdered(categoryId: Int?): Flow<List<LiveStreamWithSortOrder>> = db.liveStreamsDao().getOrdered(categoryId)
    suspend fun getOrderedTvChannelsList(categoryId: Int?): List<LiveStreamWithSortOrder> = db.liveStreamsDao().getOrderedTvChannelsList(categoryId)
    suspend fun insertToSortOrder(order: LiveStreamOrderEntity)= db.liveStreamOrderDao().insert(order)
    suspend fun resetToSortOrderFrom(category: LiveCategory?)= db.liveStreamOrderDao().deleteAllFrom(category?.categoryId?:-1)
    // In StreamControlViewModel (or repository)
    suspend fun findSortedByIndex(index: Int, categoryId: Int) =
        db.liveStreamOrderDao().getByIndex(index, categoryId)

    suspend fun findAllSorted (categoryId: Int) =
        db.liveStreamOrderDao().getAllSorted(categoryId)
    suspend fun shiftPositionsBetween(
        categoryId: Int?,
        lowerBound: Double?,
        upperBound: Double?,
        delta: Double
    ): Int {
        if (categoryId == null || lowerBound == null || upperBound == null) return 0
        return db.liveStreamOrderDao().shiftPositionsBetween(categoryId, lowerBound, upperBound, delta)
    }

    suspend fun toggleLiveCategory(category: LiveCategory){
        if (category.categoryId==null) return

       val hiddenCategory= category.toHiddenCategoryEntity(StreamType.LIVE)
       with(db.hiddenCategoryDao()) {
           val isHidden =  isHidden(category.categoryId, StreamType.LIVE)
           if (isHidden)
                unhideCategory(hiddenCategory)
           else
               hideCategory(hiddenCategory)
       }



    }
    fun getCategoriesWithVisibleStatus():
            Flow<List<LiveCategoryWithVisibleStatus>> {

    return db.liveCategoriesDao().getCategoriesWithVisibleStatus()

    }
}

